import get from 'lodash/get'
import { IShipmentStopTypes } from 'types/graphqlTypes'
import * as yup from 'yup'
import { isStopsValid, isStopTimeValid } from '../../utils'
import { ShipmentInfoSchemaObject } from './ShipmentInfoSchema/ShipmentInfoSchema'
import { ShipmentTermsSchemaObject } from './ShipmentTermsSchema/ShipmentTermsSchema'
import { StopSchema, TStopSchema } from './StopSchema'

export const VALID_STOPS_MESSAGE = 'Shipment must include at least one pickup and one delivery'
export const VALID_SHIPMENT_STOP_MESSAGE = {
  [IShipmentStopTypes.pickup]: 'Pickup date should not be after the last delivery date',
  [IShipmentStopTypes.delivery]: 'Delivery date should not be before first pickup date',
}

const SingleStopSchema = StopSchema.test({
  name: 'valid-shipment-stop',
  message: ({ value }) => get(VALID_SHIPMENT_STOP_MESSAGE, value.stopType),
  test: function checkStop(stop: TStopSchema) {
    const shipmentStops: TStopSchema[] = this.parent || []
    return isStopTimeValid(shipmentStops, stop)
  },
})

export const ShipmentSchemaObject = {
  /**
   * Includes: opsRep
   */
  ...ShipmentInfoSchemaObject,
  /**
   * Includes totalWeight, totalPallets, shipperRate, shipperRateType
   */
  ...ShipmentTermsSchemaObject,
  /**
   * Pick up and delivery stops for the shipment
   */
  stops: yup
    .array<TStopSchema>(SingleStopSchema)
    .test('valid-stops', VALID_STOPS_MESSAGE, isStopsValid),
}

export const ShipmentSchema = yup.object(ShipmentSchemaObject)

export type TShipmentSchema = yup.InferType<typeof ShipmentSchema>
